import { Component, OnDestroy, OnInit } from "@angular/core";
import { MedOptionType } from "@mk/med-ui";
import { HttpParams } from "@angular/common/http";
import { ReserveController } from "@app/ui_controllers/reserveController";
import { GoodSpecificationsResponse } from "@app/ui_models/web-response";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import {ActivatedRoute, Router} from "@angular/router";
import { DataService } from "@app/services/data.service";
import { BasketService } from "@app/components/basket/basket.service";
import { MoneyUtil } from "@app/utils/money.util";
import { PostponeController } from "@app/ui_controllers/postponeController";
import {tabHeaderReservesSpecifications} from "@app/components/reserves/reserves.component";

@Component({
  templateUrl: "./postponed.component.html",
  styleUrls: ["../reserves/reserves.component.scss"],
})
export class PostponedComponent  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly reserveController: ReserveController,
    private readonly postponeController: PostponeController,
    public dataService: DataService,
    public basketService: BasketService,
  ) {
  }

  loadingCounter = 0;
  optionsTabGroup: MedOptionType<any>[] = [
    {
      label: "Всі склади",
      value: 1,
    },
    {
      label: "Укрмедпостач",
      value: 2,
    },
    {
      label: "БЦФ",
      value: 3,
    },
  ];
  optionsModel = 1;
  pageSize = 10;
  pageSizeSpecifications = 10;
  selectedPageNumber = 1;
  selectedPageNumberSpecifications = 1;

  hideGroup1 = false;
  hideGroup2 = false;

  filterActive = true;
  filterField: string | string[] | null | undefined = "";

  postponedId: string | null = "";

  totalRowsSpecifications = 0;
  tableBodySpecifications:  GoodSpecificationsResponse [] = [];
  tabHeaderSpecifications: { label: string; key: string; date: boolean; filter: boolean; joinTable: string; showChevron: boolean; chevronOpen: boolean; hideAbleColumn: boolean; }[] = tabHeaderReservesSpecifications;

  ngOnInit(): void {
    this.postponedId = this.route.snapshot.queryParamMap.get('postponedId');
  }
  ngOnDestroy(): void {
  }

  tabGroupChanged(): void {
    this.selectedPageNumber = 1;
    // this.getGoods(this.selectedPageNumber);
    this.getSpecifications(this.selectedPageNumber);
  }

  // getGoods(
  //   page: number | undefined,
  // ): void {
  //   let params = new HttpParams();
  //   this.selectedPageNumber = page ? page : 0;
  //   if (this.optionsModel !== 1) {
  //     params = params.append("conditions[0].fieldName", "supply_warehouseName");
  //     params = params.append("conditions[0].value", this.optionsModel === 2 ? "Укрмедпостач" : "БЦФ");
  //     params = params.append("conditions[0].operator", "EQUALS");
  //   }
  //
  //   params = this.appendFilterParams(params);
  //
  //   params = params.append("page", this.selectedPageNumber - 1);
  //   params = params.append("size", this.pageSize);
  //
  //   // this.loadingCounter++;
  //   const timeoutId = setTimeout(() => {
  //     this.loadingCounter++;
  //   }, 300);
  //
  //   this.reserveController.retrieveReserveGoods(params).subscribe(data => {
  //     this.tableBodyReserveGoods = data.content;
  //     this.totalRowsReserveGoods = data.totalElements;
  //     if (this.loadingCounter === 0) {
  //       clearTimeout(timeoutId);
  //     } else {
  //       this.loadingCounter--;
  //     }
  //   }, (error: HttpErrorResponse) => {
  //     this.notificationService.error(error.message)
  //     this.loadingCounter--;
  //   });
  // }

  getSpecifications(
    page: number | undefined,
  ): void {
    let params = new HttpParams();
    this.selectedPageNumberSpecifications = page ? page : 0;
    if (this.optionsModel !== 1) {
      params = params.append("warehouseName", this.optionsModel === 2 ? "Укрмедпостач" : "БЦФ");
    }

    // params = this.appendFilterParams(params);
    if (this.postponedId) {
      params = params.append(`conditions[0].fieldName`, "id");
      params = params.append(`conditions[0].value`, this.postponedId);
      params = params.append(`conditions[0].operator`, "EQUALS");
    }

    params = params.append("page", this.selectedPageNumberSpecifications - 1);
    params = params.append("size", this.pageSizeSpecifications);
    // params = params.append("sort", sortFieldAndOrder);

    // this.loadingCounter++;
    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);
    this.postponeController.getPostponedSpecifications(params).subscribe(data => {
      this.tableBodySpecifications = data.content;
      this.totalRowsSpecifications = data.totalElements;
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    });

  }

  loadData() {
    this.getSpecifications(this.selectedPageNumberSpecifications);
  }

  filterHeader(tabHeaderSpecifications: {
    label: string;
    key: string;
    date: boolean;
    filter: boolean;
    joinTable: string;
    showChevron: boolean;
    chevronOpen: boolean;
    hideAbleColumn: boolean;
  }[]) {
    let filtered = tabHeaderSpecifications;
    let headersForFilter: string[] = [];
    if (this.hideGroup1) {
      headersForFilter = ["3", "4", "5", "6", "7", "8", "9"];
    }
    if (this.hideGroup2) {
      headersForFilter = headersForFilter.concat(["18", "19", "20", "21"]);
    }

    if (headersForFilter.length > 0) {
      filtered = tabHeaderSpecifications.filter(value => !headersForFilter.includes(value.key));
    }

    return filtered;
  }

  showHidedColumns($event: MouseEvent, columnKey: string, hide: boolean): void {
    $event.preventDefault();
    $event.stopPropagation();
    if (columnKey === "2") {
      this.hideGroup1 = hide;
    } else if (columnKey === "17") {
      this.hideGroup2 = hide;
    }
  }

  goToDetails(id: string): void {
    this.router.navigate(["/availability/" + id]);
  }

  onChangeHandlerSpecification(row: any): void {
    row.good = {direction: {id: row.directionId}};
    this.basketService.addIfNotExistsAndRemoveIfExists([row.specificationId], row.good.direction.id, row.warehouseName);
  }

  getRowSum(availableForDistribution: number, adjUnitPrice:number): string {
    return  MoneyUtil.toFixedTrunc(adjUnitPrice * availableForDistribution, 2);
  }

  pageChangeSpecifications(pageNumber: number) {
    this.selectedPageNumberSpecifications = pageNumber;
    this.loadData();
  }

  getFirstShowedRowIndexSpecifications(): number {
    return this.selectedPageNumberSpecifications === 1 ? 0 : (this.selectedPageNumberSpecifications - 1) * this.pageSizeSpecifications;
  }

  pageSizeChangedSpecifications(pageSize: number) {
    this.pageSizeSpecifications = pageSize;
    this.selectedPageNumberSpecifications = 1;
    this.loadData();
  }

  protected readonly paginationOptions = PAGINATION_OPTIONS;
}
